const axiosConfig = {
  baseURL: process.env.REACT_APP_API_URL,
};

export default axiosConfig;
